/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { TotalStatsBaseTotalsApiSubType, TotalStatsTotals } from "~/features/statistics/types";

const transformToTotalStatsTotals = (totals: TotalStatsBaseTotalsApiSubType): TotalStatsTotals => ({
  prejns: Number(totals.prejns),
  nonprejns: Number(totals.nonprejns),
  newchrgusr: Number(totals.newchrgusr),
  prepaidprejns: Number(totals.prepaidprejns),
  abvthreshusr: Number(totals.abvthreshusr),
  trstamntsuc: Number(totals.trstamntsuc),
  chargebackcount: Number(totals.chargebackcount),
  chrgbkamnt: Number(totals.chrgbkamnt),
  chrgbkcramnt: Number(totals.chrgbkcramnt),
  clicks: Number(totals.clicks),
  netpayout: Number(totals.netpayout),
  uniquelogins: Number(totals.uniquelogins),
  netrevenue: Number(totals.netrevenue),
});

export default transformToTotalStatsTotals;
